import { ExternalLink, Gauge } from "lucide-react";

import { NavigationItem } from "../../stores";
import { isScorecardNavigation, resolveEntityTypeFromNavigation } from "../../utils/toolVisual";

import { useWorkspaceToolNavigation } from "./useWorkspaceToolNavigation";

import { Button } from "@/components/ui/button";
import EntityIcon from "@/components/ui/icons/EntityIcon";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/Tooltip";
import { cn } from "@/lib/utils";

export const ToolNavigationButtons = ({
  navigation,
  className,
}: {
  navigation?: NavigationItem[];
  className?: string;
}) => {
  const handleNavigate = useWorkspaceToolNavigation();

  if (!navigation || navigation.length === 0) {
    return null;
  }

  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      <TooltipProvider delayDuration={300}>
        {navigation.map(nav => {
          const isScorecard = isScorecardNavigation(nav.url, nav.label);
          const entityType = resolveEntityTypeFromNavigation(nav.url, nav.label);
          let navIcon = <ExternalLink className="h-3 w-3" />;
          if (isScorecard) {
            navIcon = <Gauge className="h-3 w-3" />;
          } else if (entityType) {
            navIcon = <EntityIcon type={entityType} size="xs" />;
          }

          return (
            <Tooltip key={`${nav.url}-${nav.label}`}>
              <TooltipTrigger asChild>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => handleNavigate(nav.url, nav.method)}
                  className="h-7 gap-1.5 text-xs"
                >
                  {navIcon}
                  {nav.label}
                </Button>
              </TooltipTrigger>
              <TooltipContent side="top" className="max-w-xs">
                <p>{nav.reason}</p>
              </TooltipContent>
            </Tooltip>
          );
        })}
      </TooltipProvider>
    </div>
  );
};
